
import './LogoLoader.css'

export const LogoLoader = () => {
  return (
    <main className="mainLoader" >
      <p className="loader_back">
        <img src="Static/Assets/Img/logo.png" alt="" className="img_size " />
        <span className="preloader"></span>
      </p>
    </main>
  )
}